import { AnimatePresence } from "motion/react";
import { createContext, useCallback, useContext, useEffect } from "react";
import * as motion from "motion/react-client";
import useScreenDimensions from "../hooks/useScreenDimensions";
import { useHasHitLimitModal } from "../hooks/useHasHitLimitModal";
import { StandardButton } from "./standardButton";
import posthog from "posthog-js";

export const HasHitLimitModal = () => {
  const isOpen = useHasHitLimitModal(state => state.isOpen);
  const orgName = useHasHitLimitModal(state=>state.orgName);
  const goToHomePage = useCallback(() => window.location.href = 'https://www.speakingof.me', []);
  const { width, height } = useScreenDimensions();

  useEffect(() => {
    posthog.capture('Has Reached Limit', {urlPath: window.location.pathname});
  }, [isOpen])

  const cancelEvent = (e: React.MouseEvent) => e.stopPropagation();

  const closeModal = () => {
    // setIsOpen(false);
  }


  return (

    <AnimatePresence>
      {isOpen ? (
        <motion.div
          key={"campaignModal"}
          style={{
            width,
            height,
            backgroundColor: "rgba(0, 0, 0, .3)",
            position: "fixed",
            zIndex: 99999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            top: 0,
            left: 0,
          }}
          onClick={closeModal}
          animate={{ opacity: 1 }}
          initial={{ opacity: 0 }}
          exit={{ opacity: 0 }}
        >
          <div
            onClick={cancelEvent}
            style={{
              width: "40rem",
              minWidth: 400,
              backgroundColor: "white",
              padding: 24,
              borderRadius: 16,
              opacity: 1,
            }}
          >
            <div style={{fontSize: '1.25rem', fontWeight: 500, marginBottom: '1rem'}}>
              Sorry for the inconvience
            </div>
            <div style={{marginBottom: '1rem'}}>
              {orgName} has either reached their limit of reviews for this month or has deactivated their account
            </div>
            <div>
              <StandardButton buttonText="Go To Home Page" onClick={goToHomePage} />
            </div>
          </div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
};
